import { avecEcranAccesRefuse } from './Services/routes-protegees';
import {
  accesInstallationsGuard,
  accesAdministrateurGuard,
} from './Services/acces-installations.guard';
import { inject } from '@angular/core';
import { ResolveFn, Routes } from '@angular/router';
import { Parc } from './Pages/parc/parc';
import { InstallationPage } from './Pages/installation/installation';
import { Tickets } from './Pages/tickets/tickets';
import { TicketDetail } from './Pages/ticket-detail/ticket-detail';
import { Maintenance } from './Pages/maintenance/maintenance';
import { Indicateurs } from './Pages/indicateurs/indicateurs';
import { Rapports } from './Pages/rapports/rapports';
import { Graphiques } from './Pages/graphiques/graphiques';
import { Configuration } from './Pages/configuration/configuration';
import { Aide } from './Pages/aide/aide';
import { testsRoutes } from './Pages/tests/tests.routes';
import { Connexion } from './Pages/connexion/connexion';
import { RentabilitePerformance } from './Pages/rentabilite-performance/rentabilite-performance';
import { Installation as InstallationService } from './Services/installation';
import { EtatService } from './Services/etat';
import {
  checkTokenValidityAndRefreshIfNeededGuard,
  hasNoValidTokenGuard,
} from './Services/authentification';

const installationTitle: ResolveFn<string> = (route) => {
  const id = Number(route.paramMap.get('id'));
  const courante = inject(EtatService).installationCourante();
  if (courante?.id === id) return courante.nom;
  return inject(InstallationService)
    .getInstallation(id)
    .then((i) => (i ? i.nom : 'Installation'))
    .catch(() => 'Installation');
};

const installationTicketsTitle: ResolveFn<string> = (route) => {
  const id = Number(route.paramMap.get('id'));
  const courante = inject(EtatService).installationCourante();
  if (courante?.id === id) return `Tickets – ${courante.nom}`;
  return inject(InstallationService)
    .getInstallation(id)
    .then((i) => (i ? `Tickets – ${i.nom}` : 'Tickets'))
    .catch(() => 'Tickets');
};

const installationGraphiquesTitle: ResolveFn<string> = (route) => {
  const id = Number(route.paramMap.get('id'));
  const courante = inject(EtatService).installationCourante();
  if (courante?.id === id) return `Graphiques – ${courante.nom}`;
  return inject(InstallationService)
    .getInstallation(id)
    .then((i) => (i ? `Graphiques – ${i.nom}` : 'Graphiques'))
    .catch(() => 'Graphiques');
};

export const routes: Routes = avecEcranAccesRefuse([
  { path: '', redirectTo: 'parc', pathMatch: 'full' },
  {
    path: 'connexion',
    component: Connexion,
    title: 'Connexion',
    canActivate: [hasNoValidTokenGuard],
    data: { hideSiloParc: true, blankLayout: true },
  },
  { path: 'parc', component: Parc, title: 'Parc', canMatch: [accesInstallationsGuard] },
  {
    path: 'installation/:id/tickets',
    component: Tickets,
    title: installationTicketsTitle,
    canMatch: [accesInstallationsGuard],
    data: { hideParcPanel: true },
  },
  {
    path: 'installation/:id/materiel',
    loadComponent: () => import('./Pages/materiel/materiel').then((m) => m.Materiel),
    title: 'Matériel',
    canMatch: [accesAdministrateurGuard],
    data: { hideParcPanel: true },
  },
  {
    path: 'materiel',
    loadComponent: () => import('./Pages/materiel/materiel').then((m) => m.Materiel),
    title: 'Matériel',
    canMatch: [accesAdministrateurGuard],
  },
  {
    path: 'installation/:id',
    component: InstallationPage,
    title: installationTitle,
    canMatch: [accesInstallationsGuard],
    data: { hideParcPanel: true },
  },
  {
    path: 'ticket/:ticketId',
    component: TicketDetail,
    title: 'Ticket',
    canMatch: [accesInstallationsGuard],
    data: { hideParcPanel: true },
  },
  {
    path: 'tickets',
    component: Tickets,
    title: 'Tickets',
    canMatch: [accesInstallationsGuard],
    data: { hideParcPanel: true },
  },
  {
    path: 'maintenance',
    component: Maintenance,
    title: 'Maintenance',
    canMatch: [accesInstallationsGuard],
    data: { hideParcPanel: true },
  },
  {
    path: 'indicateurs',
    component: Indicateurs,
    title: 'Indicateurs',
    canMatch: [accesInstallationsGuard],
  },
  {
    path: 'rentabilite-performance',
    component: RentabilitePerformance,
    title: 'Performance',
    canMatch: [accesInstallationsGuard],
    data: { hideParcPanel: true },
  },
  { path: 'rapports', component: Rapports, title: 'Rapports', canMatch: [accesInstallationsGuard] },
  {
    path: 'installation/:id/graphiques',
    component: Graphiques,
    title: installationGraphiquesTitle,
    canMatch: [accesInstallationsGuard],
    data: { hideParcPanel: true },
  },
  {
    path: 'graphiques',
    component: Graphiques,
    title: 'Graphiques',
    canMatch: [accesInstallationsGuard],
  },
  {
    path: 'configuration',
    component: Configuration,
    title: 'Configuration',
    canMatch: [accesAdministrateurGuard],
  },
  {
    path: 'aide',
    component: Aide,
    title: 'Aide',
    canActivate: [checkTokenValidityAndRefreshIfNeededGuard],
    data: { hideSiloParc: true },
  },
  {
    path: 'assistant',
    loadComponent: () => import('./Pages/assistant/assistant').then((m) => m.AssistantComponent),
    title: 'Assistant création',
    canActivate: [checkTokenValidityAndRefreshIfNeededGuard],
    data: { hideSiloParc: true },
  },
  ...testsRoutes,
]);
